import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=6511444e&scoped=true"
import script from "./SideDrawer.vue?vue&type=script&lang=js"
export * from "./SideDrawer.vue?vue&type=script&lang=js"
import style0 from "./SideDrawer.vue?vue&type=style&index=0&id=6511444e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6511444e",
  null
  
)

export default component.exports